// If you edit this, remember to also edit the corresponding enum in
// jore4-test-db-manager/src/types/enums.ts
export enum KnownValueKey {
  ValidityStart = 'validityStart',
  ValidityEnd = 'validityEnd',
  Priority = 'priority',
  FunctionalArea = 'functionalArea',
  RailReplacement = 'railReplacement',
  Virtual = 'virtual',
  StreetAddress = 'streetAddress',
  PostalCode = 'postalCode',
  Municipality = 'municipality',
  FareZone = 'fareZone',
  TerminalType = 'terminalType',
  DeparturePlatforms = 'departurePlatforms',
  ArrivalPlatforms = 'arrivalPlatforms',
  LoadingPlatforms = 'loadingPlatforms',
  ElectricCharging = 'electricCharging',
  ElyNumber = 'elyNumber',
  ImportedId = 'imported-id',
  StopState = 'stopState',
  StopOwner = 'stopOwner',
  OwnerContractId = 'owner-contractId',
  OwnerNote = 'owner-note',
  TimingPlaceId = 'timingPlaceId',
  SpeedTramStop = 'speedTramStop',
  TrunkLineStop = 'trunkLineStop',
  Mirrors = 'mirrors',
  SortOrder = 'sortOrder',
}
